import { render, staticRenderFns } from "./ListOrderReturn.vue?vue&type=template&id=2901c4dc&"
import script from "./ListOrderReturn.vue?vue&type=script&lang=js&"
export * from "./ListOrderReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports